import { render, staticRenderFns } from "./SustainabilityItems.vue?vue&type=template&id=ec084234&"
import script from "./SustainabilityItems.vue?vue&type=script&lang=js&"
export * from "./SustainabilityItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports